<script setup lang="ts">
import type { FilterButtonClickedPageType as PageType } from "~/analytics/segment";

type Props = {
  filterCount?: number;
  pageType?: PageType;
  showSmallButtonFrom?: "mobile" | "tablet";
  showText?: boolean;
};

const {
  filterCount,
  pageType,
  showSmallButtonFrom = "mobile",
  showText = false,
} = defineProps<Props>();

type Emits = {
  (e: "open-filter-menu"): void;
};

const emit = defineEmits<Emits>();

const { filterButtonClicked } = useAnalytics();
const onFilterButtonClicked = () => {
  if (pageType !== undefined) {
    filterButtonClicked({ page_type: pageType });
  }
  emit("open-filter-menu");
};
</script>

<template>
  <button
    class="lg:hidden interaction-dark flex flex-row gap-1 items-center"
    :class="{
      'md:hidden': showSmallButtonFrom === 'mobile',
    }"
    aria-label="open filter menu"
    @click="onFilterButtonClicked"
  >
    <BaseIcon
      v-bind="$attrs"
      class="min-w-[20px]"
      name="settings"
      :size="20"
    />
    <span
      v-if="showText"
      class="uppercase font-bold"
    >
      {{ $t("filter.title") }}
    </span>
    <BaseCounter
      v-if="filterCount"
      class="h-5 w-5"
      data-test="base-counter"
      :count="filterCount"
    />
  </button>
  <BaseButtonMWS
    v-bind="$attrs"
    class="hidden relative flex-row gap-2 items-center justify-center min-w-32 h-11 w-fit"
    :class="{
      'md:flex': showSmallButtonFrom === 'mobile',
    }"
    color-scheme="transparent"
    @click="onFilterButtonClicked"
  >
    <BaseIcon
      name="settings"
      class="interaction-dark"
      :size="20"
    />
    <div class="text-nowrap">{{ $t("filter.title") }}</div>
    <BaseCounter
      v-if="filterCount"
      class="h-5 w-5"
      data-test="base-counter"
      :count="filterCount"
    />
  </BaseButtonMWS>
</template>
